'use client';
import Pdf from '@/app/_components/ui/icons/Pdf.svg';
import React from 'react';
import Link from 'next/link';
import { useState } from 'react';
import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';

export default function SpCatalog({ catalogues }) {
  const [closeSection, setCloseSection] = useState(false);
  return (
    <>
      {catalogues.data.length > 0 && (
        <div
          className="spCatalogs mt-3 md:mt-8 p-0 md:p-8 bg-white"
          id="spCatalogs"
        >
          <div className="flex md:pb-6 md:pt-0 md:px-0 p-4 justify-between border-b border-light-gray-300 md:border-none">
            <div className="spNavTitle font-bold">کاتالوگ ها</div>
            <div
              className="md:hidden"
              onClick={() => setCloseSection((prev) => !prev)}
            >
              <ArrowTop className={`${closeSection && 'rotate-180'}`} />
            </div>
          </div>

          <div
            className={`${
              closeSection
                ? 'mt-0 p-0 h-0 overflow-hidden '
                : 'mt-4 md:mt-0 p-2 md:p-0 '
            }`}
          >
            <div className="md:flex md:-mx-3">
              {(catalogues.type == 'upload' || catalogues.type == 'url') &&
                catalogues.data.map((catalog, index) => (
                  <div
                    className="flex-1 md:max-w-[33.333333%] md:px-3 mb-2.5 md:mb-0"
                    key={index}
                  >
                    <Link
                      href={
                        catalogues.type == 'upload'
                          ? catalog?.full_path || '#'
                          : catalog?.url || '#'
                      }
                      target="_blank"
                    >
                      <div className="flex  px-8 py-6 items-center bg-ghost-white">
                        <Pdf />
                        <span className="pr-3 text-sm">
                          {catalogues.type == 'upload'
                            ? catalog.caption
                            : catalog.name}
                        </span>
                      </div>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
